/* Full-viewport centered loading indicator used by route guards while they
   resolve the async auth/role check. */
export default function FullPageSpinner() {
  return (
    <div className="min-h-screen grid place-items-center">
      <span className="text-muted-foreground">Chargement…</span>
    </div>
  );
}
